
import Errors from './Errors.vue'; 
import Form from './Form.vue';
import Fieldset from './Fieldset.vue';
import DateOfBirth from './DateOfBirth.vue'; 
import RadioList from './RadioList.vue'; 
import RadioButton from './RadioButton.vue'; 
import CheckboxList from './CheckboxList.vue'; 
import CheckboxButton from './CheckboxButton.vue'; 
import DateOfBirthInput from './DateOfBirthInput.vue';
import TextInput from './TextInput.vue';
import Textarea from './Textarea.vue';
import Dropdown from './Dropdown.vue';
import IntroForm from './IntroForm.vue'; 
import Submit from './Submit.vue';

export default  {
	Errors,
	Form,
	Fieldset,
	TextInput,
	Textarea,
	Dropdown,
	IntroForm,
	DateOfBirth,
	DateOfBirthInput,
	RadioList,
	RadioButton,
	CheckboxList,
	CheckboxButton,
	Submit
};